__turbopack_context__.v({
  "checkbox": "stepsProgress-module-scss-module__TiR0Xq__checkbox",
  "completed": "stepsProgress-module-scss-module__TiR0Xq__completed",
  "lowCompleted": "stepsProgress-module-scss-module__TiR0Xq__lowCompleted",
  "partlyCompleted": "stepsProgress-module-scss-module__TiR0Xq__partlyCompleted",
  "passed": "stepsProgress-module-scss-module__TiR0Xq__passed",
  "step": "stepsProgress-module-scss-module__TiR0Xq__step",
  "stepsWrp": "stepsProgress-module-scss-module__TiR0Xq__stepsWrp",
  "text": "stepsProgress-module-scss-module__TiR0Xq__text",
  "tooltipContainer": "stepsProgress-module-scss-module__TiR0Xq__tooltipContainer",
  "tooltipStep": "stepsProgress-module-scss-module__TiR0Xq__tooltipStep",
  "tooltipStepsWrp": "stepsProgress-module-scss-module__TiR0Xq__tooltipStepsWrp",
});
